"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumMapper = void 0;
var EnumMapper = /** @class */ (function () {
    function EnumMapper(map) {
        this.map = map;
    }
    EnumMapper.prototype.toVod = function (v3) {
        return this.map[v3];
    };
    EnumMapper.prototype.toGql = function (v2) {
        for (var v3 in this.map) {
            if (this.map[v3] === v2) {
                return v3;
            }
        }
    };
    return EnumMapper;
}());
exports.EnumMapper = EnumMapper;
//# sourceMappingURL=enum-mapper.js.map